import useRoleMutation from "~/pages/RegistryOfRole/hooks/useRoleMutation";

export default function useAddCopyRole() {
  return useRoleMutation(
    "/internal-api/auth/access/role/copy",
    "POST",
    "addCopyRole",
  );
}
